import React from 'react';
import ProjectQuoteInvoice from './../../ProjectQuoteInvoice';

const ProjectPlanTab = ({ SelectedBrief, SelectedProfessional, IsInfoEdit }) => {
    return (
        <div className='BriefInfoSection' style={{ padding: '0% 1%' }}>
            <ProjectQuoteInvoice 
                Brief={SelectedBrief} 
                SelectedPro={SelectedProfessional} 
                isEditProjectPlan={IsInfoEdit} 
                getUpdated={(event) => { }} 
            />
        </div>
    );
};

export default ProjectPlanTab;